// extracted by mini-css-extract-plugin
export var content = "WaterCoolerItem-module--content--wo3OD";
export var contentImage = "WaterCoolerItem-module--content-image--J-YfH";
export var contentImageInner = "WaterCoolerItem-module--content-image-inner--7JFHH";
export var contentImageInnerGlow = "WaterCoolerItem-module--content-image-inner-glow--qg+AK";
export var contentPrint = "WaterCoolerItem-module--content-print---CnzZ";
export var contentTitle = "WaterCoolerItem-module--content-title--uq-j1";